// sidebarMenu — 사이드바 기본 메뉴(DEFAULT_NAV) + 관리자 설정(app_settings 'sidebar_menu') 적용.
// 기본값의 정본은 이 파일의 DEFAULT_NAV 하나다(서버는 키 목록을 따로 들지 않는다).
// 설정 모양: { version:1, entries:[ {type:'group', name} | {type:'item', key, label?, hidden?} ] }
//   - 순서 = entries 순서 · 그룹 = group 원소 · 이름 = label(비면 기본 이름) · 숨김 = hidden(권한 아님).

/* ── 메뉴 설정(확장 지점) — 앱/링크 추가는 이 배열에 한 줄 추가하면 됨 ──
 *  DEFAULT_NAV: 상단 메인 앱. content:true면 현재 앱일 때 children(페이지 콘텐츠)을 아코디언으로 펼침.
 *       ⚠️노출/접근 권한은 **utils/menuAccess.canSeeMenu(단일소스)** 로만 판정한다(가시성=라우트 가드 동일).
 *          여기엔 게이트 필드를 두지 않는다 — 옛 `gate` 필드는 코드가 안 읽던 잔재라 제거(#125, 혼동 원천 차단).
 *          권한을 바꾸려면 menuAccess.js를 고칠 것(예: DRIVE_GATED·전용 access 플래그).
 *       (확장 예) { key:'messenger', label:'메신저', path:'/messenger' }  ← iframe 임베드든 네이티브든 path만 잡으면 됨
 */
// 섹션 그룹: { section: '라벨' }은 회색 헤더로 렌더(그 섹션에 보이는 항목이 하나도 없으면 헤더도 숨김).
export const DEFAULT_NAV = [
  { key: 'home',      label: '메인',      path: '/home' },
  { key: 'help',      label: '사용 안내', path: '/help' },
  { key: 'my',        label: '내 정보',   path: '/my' },
  { section: 'AI' },
  { key: 'chat',      label: 'AI 채팅',   path: '/' },
  { key: 'generated', label: '만든 파일', path: '/generated' },
  { key: 'meetings',  label: 'AI 노트',   path: '/meetings' },
  { key: 'documents', label: 'AI 학습자료 등록', path: '/documents' },
  { key: 'docauto',   label: 'AI 문서 자동화', path: '/doc-automation' },
  { section: '협업' },
  { key: 'messenger', label: '메신저',    path: '/messenger' },
  { key: 'drive',     label: '드라이브',  path: '/drive-app' },
  { key: 'office',    label: '오피스',    path: '/office' },
  { key: 'calendar',  label: '캘린더',    path: '/calendar' },
  // 🔴 옛 '메일'(NC Mail 임베드)은 메뉴에서 뺐다(마스터 2026-08-24). 메일은 Roundcube 한 곳으로 모은다 —
  //    같은 메일함을 두 화면으로 보여주면 어디서 뭘 했는지 사용자가 못 따라간다.
  //    key 는 'mail2' 그대로 둔다(메뉴 권한·라우트·백엔드 게이트가 이 키로 묶여 있다).
  { key: 'mail2',     label: '메일',      path: '/mail2' },
  { key: 'talk',      label: '화상회의',  path: '/talk' },
  { key: 'collabtools', label: '협업 도구', path: '/collab-tools' },
  // AI 개발실(#2624 ④-S) — 서버 레지스트리 순서(collabtools → apps → dxboard)와 같은 자리 · 보이기는 menuAccess(apps)
  { key: 'apps',      label: 'AI 개발실', path: '/aidev' },
  { key: 'dxboard',   label: 'AX 보드',   path: '/dx-board' },
  { key: 'execmeeting', label: '임원회의', path: '/exec-meeting' },
  { key: 'supportboard', label: '경영지원팀 보드', path: '/support-board' },
  { section: '소통·업무' },
  { key: 'directory', label: '조직도',    path: '/directory' },
  { key: 'inquiries', label: '문의게시판', path: '/inquiries' },
  { key: 'devreq',    label: '개발요청',   path: '/dev-requests' },
  { key: 'board',     label: '사내게시판', path: '/board' },
  { key: 'tickets',   label: 'CS 티켓',    path: '/tickets' },
  { key: 'taskpm',    label: '업무 프로젝트', path: '/tasks' },
  { key: 'abc-analysis', label: 'ABC분석', path: '/abc-analysis' },
  { key: 'contracts', label: '계약 관리', path: '/contracts' },
  { key: 'pdas',      label: '농심DAS',   path: '/pdas' },
  { key: 'dispatch-calc', label: '배차 계산기', path: '/dispatch-calc' },
  { key: 'inbound-capa', label: '입고예정 통합관리', path: '/inbound-capa' },
  { key: 'capa',      label: '네이버 CAPA', path: '/capa' },
  // 업무 통합(개발요청 1-운영-10 · 1단계 고객사 기준 정보) — '클레임' 앞. 나머지 4개 메뉴는 이 그룹에 이어 붙인다.
  //   편집 권한 work-customers-edit 는 메뉴 줄이 아니라 권한으로만 쓴다(menuAccess · 서버 require_menu).
  //   옛 저장 설정에는 withWorkGroupIfUnset 이 그룹 머리째 넣는다(없으면 capa 뒤 '소통·업무' 아래로 섞인다).
  { section: '업무 통합' },
  { key: 'work-customers', label: '고객사 기준 정보 및 이력관리', path: '/work-customers' },
  // 클레임 기준(1단계) — '센터' 앞에 둔다(뒤에 두면 옛 저장 설정에서 withCenterGroupIfUnset 이 센터를 클레임 뒤로 넣어 순서가 갈린다).
  //   편집 권한 claim-admin 은 메뉴 줄이 아니라 권한으로만 쓴다(menuAccess · 서버 require_menu).
  //   클레임 등록(2단계)은 그룹 첫 줄 — 저장된 설정에 '클레임' 머리가 있으면 mergeMissingDefaults 가 그 머리 바로 뒤에 끼운다.
  { section: '클레임' },
  { key: 'claim-register',  label: '클레임 등록',     path: '/claims/register' },
  { key: 'claim-standards', label: '보상기준 마스터', path: '/claims/standards' },
  { key: 'claim-reasons',   label: '사유코드 관리',   path: '/claims/reasons' },
  // 센터 메뉴는 menu_registry 일반 권한(2026-10-23 마스터 «다른 메뉴처럼») · 센터별 항목은 withCenterSites 가 이 그룹 머리 바로 뒤에 넣는다
  { section: '센터' },
  { key: 'center-all',      label: '센터 비용 통합조회', path: '/center-costs' },
  { key: 'center-daily',    label: '센터 일별 실적',     path: '/center-daily' },
  { key: 'center-shippers', label: '센터 고객사 명부',   path: '/center-shippers' },
  { key: 'center-perf',     label: '센터 실적 대시보드', path: '/center-performance' },
  { section: '관리' },
  { key: 'admin',     label: '관리자',    path: '/admin' },
];

export const SIDEBAR_MENU_CACHE_KEY = 'gwSidebarMenu';
// 같은 창의 다른 화면(관리자 저장)이 캐시를 바꿨다는 신호 — AppSidebar 가 듣고 캐시를 다시 읽는다.
export const SIDEBAR_MENU_EVENT = 'gw-sidebar-menu';
// 관리자가 스스로 관리자 메뉴를 잃지 않게 · 내 정보는 계정 설정 입구라 — 숨김이어도 넣는다(서버도 저장을 거부한다).
// 서버 routers/sidebar_menu.py ALWAYS_SHOWN_KEYS 와 같은 값.
export const ALWAYS_SHOWN_KEYS = new Set(['admin', 'my']);

const isGroup = (x) => !!x && typeof x.section === 'string';
const isMenu = (x) => !!x && !x.section && typeof x.key === 'string';
const cleanText = (v) => (typeof v === 'string' ? v.trim() : '');

// 기본 메뉴(DEFAULT_NAV 모양)를 설정 entries 모양으로 바꾼다 — 설정이 없을 때의 출발점.
const navToEntries = (base) => base.map((x) => (isGroup(x)
  ? { type: 'group', name: x.section }
  : { type: 'item', key: x.key }));

/**
 * 규칙 3·4 — 모르는 key·중복을 버리고, entries 에 없는 기본 메뉴(설정 저장 뒤 코드로 새로 생긴 메뉴)를 끼워 넣는다.
 * 숨김 항목은 지우지 않는다(관리자 화면이 같은 함수를 쓴다).
 *  - base 순서대로 하나씩 넣으므로 연달아 빠진 둘(a, b)은 a, b 순서가 유지된다.
 *  - 그룹 첫 메뉴는 결과에 같은 이름 그룹 헤더가 있으면 그 바로 뒤에, 없으면 «앞 메뉴» 규칙을 따른다.
 *  - «앞 메뉴»: base 에서 그 메뉴 앞의 메뉴(그룹 제외)를 거꾸로 보며 결과에 있는 첫 메뉴 뒤에. 끝까지 없으면 맨 앞.
 */
export function mergeMissingDefaults(entries, base = DEFAULT_NAV) {
  if (!Array.isArray(entries)) return navToEntries(base);
  const baseKeys = new Set(base.filter(isMenu).map((x) => x.key));
  const seenKeys = new Set();
  const seenGroups = new Set();
  const out = [];
  entries.forEach((e) => {
    if (!e || typeof e !== 'object') return;
    if (e.type === 'group') {
      const name = cleanText(e.name);
      if (!name || seenGroups.has(name)) return;   // 같은 이름 헤더 둘이면 React key 가 겹친다
      seenGroups.add(name);
      out.push({ type: 'group', name });
      return;
    }
    if (e.type !== 'item' || typeof e.key !== 'string') return;
    if (!baseKeys.has(e.key) || seenKeys.has(e.key)) return;   // 규칙 3
    seenKeys.add(e.key);
    const item = { type: 'item', key: e.key };
    const label = cleanText(e.label);
    if (label) item.label = label;
    if (e.hidden === true) item.hidden = true;
    out.push(item);
  });

  const indexOfKey = (key) => out.findIndex((x) => x.type === 'item' && x.key === key);
  base.forEach((b, i) => {
    if (!isMenu(b) || seenKeys.has(b.key)) return;
    let at = -1;
    // 그룹 첫 메뉴인가 — 거꾸로 보며 메뉴보다 그룹 헤더를 먼저 만나면 그렇다.
    let groupName = null;
    for (let j = i - 1; j >= 0; j -= 1) {
      if (isMenu(base[j])) break;
      if (isGroup(base[j])) { groupName = base[j].section; break; }
    }
    if (groupName !== null) {
      const h = out.findIndex((x) => x.type === 'group' && x.name === groupName);
      if (h >= 0) at = h + 1;
    }
    if (at < 0) {
      at = 0;
      for (let j = i - 1; j >= 0; j -= 1) {
        if (!isMenu(base[j])) continue;
        const p = indexOfKey(base[j].key);
        if (p >= 0) { at = p + 1; break; }
      }
    }
    out.splice(at, 0, { type: 'item', key: b.key });
    seenKeys.add(b.key);
  });
  return out;
}

/**
 * 설정을 적용한 메뉴 배열 — 모양은 DEFAULT_NAV 와 같다({section} 과 {key,label,path} 혼합).
 * 설정이 없거나 entries 가 배열이 아니면 base 복사본.
 */
export function resolveNav(config, base = DEFAULT_NAV) {
  if (!config || !Array.isArray(config.entries)) return base.map((x) => ({ ...x }));
  const byKey = new Map(base.filter(isMenu).map((x) => [x.key, x]));
  const out = [];
  mergeMissingDefaults(config.entries, base).forEach((e) => {
    if (e.type === 'group') { out.push({ section: e.name }); return; }
    if (e.hidden && !ALWAYS_SHOWN_KEYS.has(e.key)) return;   // 규칙 5
    const item = { ...byKey.get(e.key) };
    if (e.label) item.label = e.label;
    out.push(item);
  });
  return out;
}

// ── 센터 메뉴(2026-10-23 일반 메뉴 권한) ──
// 센터별 메뉴(center:<token>)는 계정·서버마다 센터 목록이 달라 DEFAULT_NAV 에 못 박는다 — withCenterSites 가 base 에 끼운다.
export const CENTER_GROUP = '센터';
export const CENTER_SITE_PREFIX = 'center:';
export const centerSiteKey = (token) => CENTER_SITE_PREFIX + token;
const isCenterSiteKey = (key) => typeof key === 'string' && key.startsWith(CENTER_SITE_PREFIX);
// «새 센터 배치의 흔적» 판정용 — center-perf 는 옛 DEFAULT_NAV 에도 있어 한 번 저장한 설정엔 반드시 들어 있다(흔적이 아니다).
const CENTER_TRACE_KEYS = new Set(['center-all', 'center-daily', 'center-shippers']);
const CENTER_PERF_KEY = 'center-perf';

// 센터 묶음 자리 — 그룹 이름('관리')이 아니라 **admin 메뉴가 든 그룹 머리 앞**(이름을 바꿔도 따라간다).
//   admin 앞에 머리가 없으면 admin 뒤의 첫 머리, 그것도 없으면 끝. admin 이 없으면 '관리' 머리, 그것도 없으면 끝.
const anchorIndexOf = (list, isHead, isAdmin, headName) => {
  const adminAt = list.findIndex(isAdmin);
  if (adminAt < 0) {
    const named = list.findIndex((x) => isHead(x) && headName(x) === '관리');
    return named >= 0 ? named : list.length;
  }
  for (let i = adminAt - 1; i >= 0; i -= 1) { if (isHead(list[i])) return i; }
  for (let i = adminAt + 1; i < list.length; i += 1) { if (isHead(list[i])) return i; }
  return list.length;
};
const navAnchorIndex = (nav) => anchorIndexOf(nav, isGroup, (x) => isMenu(x) && x.key === 'admin', (x) => x.section);
const isEntryGroup = (e) => !!e && typeof e === 'object' && e.type === 'group';
const isEntryItem = (e) => !!e && typeof e === 'object' && e.type === 'item' && typeof e.key === 'string';
const entryAnchorIndex = (entries) => anchorIndexOf(entries, isEntryGroup, (e) => isEntryItem(e) && e.key === 'admin', (e) => cleanText(e.name));

/**
 * 센터별 메뉴 항목을 base 의 '센터' 그룹 머리 바로 뒤에 끼운 새 배열 — centers = [{token, name}](서버 순서).
 * '센터' 머리가 없으면 센터 묶음 자리(admin 이 든 그룹 머리 앞 · 보통 '관리' 머리 앞), 그것도 없으면 끝.
 * 항목 모양 = { key: 'center:'+token, label: name, path: '/center/'+encodeURIComponent(token) }. 같은 token 두 번은 앞의 것.
 */
export function withCenterSites(base, centers) {
  const list = Array.isArray(base) ? base : [];
  const taken = new Set(list.filter(isMenu).map((x) => x.key));
  const sites = [];
  (Array.isArray(centers) ? centers : []).forEach((c) => {
    const token = c && typeof c.token === 'string' ? c.token : '';
    if (!token || taken.has(centerSiteKey(token))) return;
    taken.add(centerSiteKey(token));
    sites.push({ key: centerSiteKey(token), label: cleanText(c.name) || token, path: '/center/' + encodeURIComponent(token) });
  });
  if (!sites.length) return list.slice();
  const head = list.findIndex((x) => isGroup(x) && x.section === CENTER_GROUP);
  const at = head >= 0 ? head + 1 : navAnchorIndex(list);
  return [...list.slice(0, at), ...sites, ...list.slice(at)];
}

// 흔적이 있는 설정 — 그대로 두되, 저장에 없는 새 센터(center:)만 저장된 마지막 center: 항목 바로 뒤(없으면 center-all 바로 앞)에 넣는다.
//   둘 다 없으면 그대로(mergeMissingDefaults 기본 규칙 — '센터' 머리가 있으면 그 뒤).
function placeNewCenterSites(entries, base, savedKeys) {
  const fresh = base.filter((x) => isMenu(x) && isCenterSiteKey(x.key) && !savedKeys.has(x.key))
    .map((x) => ({ type: 'item', key: x.key }));
  if (!fresh.length) return entries;
  let lastSite = -1;
  entries.forEach((e, i) => { if (isEntryItem(e) && isCenterSiteKey(e.key)) lastSite = i; });
  if (lastSite >= 0) return [...entries.slice(0, lastSite + 1), ...fresh, ...entries.slice(lastSite + 1)];
  const all = entries.findIndex((e) => isEntryItem(e) && e.key === 'center-all');
  if (all >= 0) return [...entries.slice(0, all), ...fresh, ...entries.slice(all)];
  return entries;
}

/**
 * 저장된 설정(entries 모양)에 «새 센터 배치의 흔적» — '센터' 그룹, 또는 center-all·center-daily·center-shippers·center:<token>
 * 항목 — 이 하나도 없을 때만 '센터' 그룹 + base 의 센터 항목(저장에 키가 없는 것만 · base 순서)을 센터 묶음 자리에 넣는다.
 *  - mergeMissingDefaults 는 그룹 머리를 안 넣는다 — 이게 없으면 옛 설정에서 센터 항목이 capa 뒤 «소통·업무» 아래로 섞인다.
 *  - 저장된 center-perf 가 옛 기본 자리(센터 묶음 자리 바로 앞)에 있으면 저장 객체 그대로(label·hidden 유지) 새 그룹 끝으로 옮기고,
 *    다른 자리면 관리자가 옮긴 것이라 그 자리·객체 그대로.
 *  - 흔적이 하나라도 있으면 관리자가 정한 배치를 건드리지 않는다(새로 생긴 센터만 placeNewCenterSites).
 *  - entries 가 배열이 아니면 그대로 돌려준다.
 */
export function withCenterGroupIfUnset(entries, base = DEFAULT_NAV) {
  if (!Array.isArray(entries)) return entries;
  const list = Array.isArray(base) ? base : DEFAULT_NAV;
  const savedKeys = new Set(entries.filter(isEntryItem).map((e) => e.key));
  const traced = entries.some((e) => (isEntryGroup(e) && cleanText(e.name) === CENTER_GROUP)
    || (isEntryItem(e) && (CENTER_TRACE_KEYS.has(e.key) || isCenterSiteKey(e.key))));
  if (traced) return placeNewCenterSites(entries, list, savedKeys);

  // base 의 센터 항목 = '센터' 머리 뒤 다음 머리 전까지(머리가 없으면 center-*·center: 키).
  const head = list.findIndex((x) => isGroup(x) && x.section === CENTER_GROUP);
  let centerItems;
  if (head >= 0) {
    centerItems = [];
    for (let i = head + 1; i < list.length && !isGroup(list[i]); i += 1) { if (isMenu(list[i])) centerItems.push(list[i]); }
  } else {
    centerItems = list.filter((x) => isMenu(x) && (CENTER_TRACE_KEYS.has(x.key) || x.key === CENTER_PERF_KEY || isCenterSiteKey(x.key)));
  }
  const block = [{ type: 'group', name: CENTER_GROUP }];
  centerItems.forEach((x) => { if (!savedKeys.has(x.key)) block.push({ type: 'item', key: x.key }); });

  let rest = entries;
  const perfAt = entries.findIndex((e) => isEntryItem(e) && e.key === CENTER_PERF_KEY);
  if (perfAt >= 0) {
    const without = entries.slice(0, perfAt).concat(entries.slice(perfAt + 1));
    if (perfAt === entryAnchorIndex(without)) {   // 옛 기본 자리 = 센터 묶음 자리 바로 앞
      block.push(entries[perfAt]);
      rest = without;
    }
  }
  const at = entryAnchorIndex(rest);
  return [...rest.slice(0, at), ...block, ...rest.slice(at)];
}

// ── 클레임 메뉴(2026-10-28 클레임 기준 1단계) ──
export const CLAIM_GROUP = '클레임';
const CLAIM_KEY_PREFIX = 'claim-';
const isClaimKey = (key) => typeof key === 'string' && key.startsWith(CLAIM_KEY_PREFIX);

/**
 * 저장된 설정(entries 모양)에 '클레임' 그룹 머리도 claim- 키 항목도 없을 때만 '클레임' 그룹 + base 의 클레임 항목
 * ('클레임' 머리 뒤 다음 머리 전까지 · 저장에 키가 없는 것만 · base 순서)을 '센터' 그룹 머리 바로 앞에 넣는다.
 * '센터' 머리가 없으면 센터 묶음 자리(admin 이 든 그룹 머리 앞).
 *  - mergeMissingDefaults 는 그룹 머리를 안 넣는다 — 이게 없으면 옛 설정에서 클레임 항목이 capa 뒤 «소통·업무» 아래로 섞인다.
 *  - 흔적이 하나라도 있으면 관리자가 정한 배치를 건드리지 않는다 · base 에 클레임 항목이 없으면 그대로.
 *  - withCenterGroupIfUnset 다음에 부른다(센터 먼저 → 클레임) — 그래야 옛 설정이 DEFAULT_NAV 와 같은 순서가 된다.
 *  - entries 가 배열이 아니면 그대로 돌려준다.
 */
export function withClaimGroupIfUnset(entries, base = DEFAULT_NAV) {
  if (!Array.isArray(entries)) return entries;
  const list = Array.isArray(base) ? base : DEFAULT_NAV;
  const traced = entries.some((e) => (isEntryGroup(e) && cleanText(e.name) === CLAIM_GROUP)
    || (isEntryItem(e) && isClaimKey(e.key)));
  if (traced) return entries;

  const savedKeys = new Set(entries.filter(isEntryItem).map((e) => e.key));
  const head = list.findIndex((x) => isGroup(x) && x.section === CLAIM_GROUP);
  const block = [{ type: 'group', name: CLAIM_GROUP }];
  if (head >= 0) {
    for (let i = head + 1; i < list.length && !isGroup(list[i]); i += 1) {
      if (isMenu(list[i]) && !savedKeys.has(list[i].key)) block.push({ type: 'item', key: list[i].key });
    }
  }
  if (block.length === 1) return entries;

  const centerAt = entries.findIndex((e) => isEntryGroup(e) && cleanText(e.name) === CENTER_GROUP);
  const at = centerAt >= 0 ? centerAt : entryAnchorIndex(entries);
  return [...entries.slice(0, at), ...block, ...entries.slice(at)];
}

// ── 업무 통합 메뉴(2026-11-03 개발요청 1-운영-10 · 1단계 고객사 기준 정보) ──
export const WORK_GROUP = '업무 통합';
const WORK_KEY_PREFIX = 'work-';
const isWorkKey = (key) => typeof key === 'string' && key.startsWith(WORK_KEY_PREFIX);

/**
 * 저장된 설정(entries 모양)에 '업무 통합' 그룹 머리도 work- 키 항목도 없을 때만 '업무 통합' 그룹 + base 의 그 그룹 항목
 * ('업무 통합' 머리 뒤 다음 머리 전까지 · 저장에 키가 없는 것만 · base 순서)을 '클레임' 그룹 머리 바로 앞에 넣는다.
 * '클레임' 머리가 없으면 '센터' 머리 앞, 그것도 없으면 센터 묶음 자리(admin 이 든 그룹 머리 앞).
 *  - mergeMissingDefaults 는 그룹 머리를 안 넣는다 — 이게 없으면 옛 설정에서 work-customers 가 capa 뒤 «소통·업무» 아래로 섞인다.
 *  - 흔적이 하나라도 있으면 관리자가 정한 배치를 건드리지 않는다 · base 에 그 그룹 항목이 없으면 그대로.
 *  - withClaimGroupIfUnset 다음에 부른다(센터 → 클레임 → 업무 통합) — 그래야 옛 설정이 DEFAULT_NAV 와 같은 순서가 된다.
 *  - entries 가 배열이 아니면 그대로 돌려준다.
 */
export function withWorkGroupIfUnset(entries, base = DEFAULT_NAV) {
  if (!Array.isArray(entries)) return entries;
  const list = Array.isArray(base) ? base : DEFAULT_NAV;
  const traced = entries.some((e) => (isEntryGroup(e) && cleanText(e.name) === WORK_GROUP)
    || (isEntryItem(e) && isWorkKey(e.key)));
  if (traced) return entries;

  const savedKeys = new Set(entries.filter(isEntryItem).map((e) => e.key));
  const head = list.findIndex((x) => isGroup(x) && x.section === WORK_GROUP);
  const block = [{ type: 'group', name: WORK_GROUP }];
  if (head >= 0) {
    for (let i = head + 1; i < list.length && !isGroup(list[i]); i += 1) {
      if (isMenu(list[i]) && !savedKeys.has(list[i].key)) block.push({ type: 'item', key: list[i].key });
    }
  }
  if (block.length === 1) return entries;

  const claimAt = entries.findIndex((e) => isEntryGroup(e) && cleanText(e.name) === CLAIM_GROUP);
  const centerAt = entries.findIndex((e) => isEntryGroup(e) && cleanText(e.name) === CENTER_GROUP);
  let at;
  if (claimAt >= 0) at = claimAt;
  else if (centerAt >= 0) at = centerAt;
  else at = entryAnchorIndex(entries);
  return [...entries.slice(0, at), ...block, ...entries.slice(at)];
}

// 메뉴 이름 하나 — 설정 라벨이 있으면 그것, 없으면 DEFAULT_NAV 라벨(모바일 하단 탭이 쓴다).
export function menuLabel(key, config) {
  if (config && Array.isArray(config.entries)) {
    const e = config.entries.find((x) => x && x.type === 'item' && x.key === key);
    const label = e ? cleanText(e.label) : '';
    if (label) return label;
  }
  const d = DEFAULT_NAV.find((x) => isMenu(x) && x.key === key);
  return d ? d.label : String(key);
}

export function readCachedConfig() {
  try {
    const raw = localStorage.getItem(SIDEBAR_MENU_CACHE_KEY);
    if (!raw) return null;
    const cfg = JSON.parse(raw);
    return cfg && typeof cfg === 'object' && !Array.isArray(cfg) ? cfg : null;
  } catch (e) {
    return null;
  }
}

// cfg 가 null 이면 캐시를 지운다(= 기본값). 쓰고 나면 같은 창의 사이드바에 알린다.
export function writeCachedConfig(cfg) {
  try {
    if (cfg) localStorage.setItem(SIDEBAR_MENU_CACHE_KEY, JSON.stringify(cfg));
    else localStorage.removeItem(SIDEBAR_MENU_CACHE_KEY);
  } catch (e) { /* 저장 공간 부족·사생활 모드 — 캐시 없이 동작 */ }
  try { window.dispatchEvent(new Event(SIDEBAR_MENU_EVENT)); } catch (e) { /* noop */ }
}
